module Meevo.Plugins.OnlineBookingSettings {
    import SettingsDto = Meevo.Model.SettingsDto;
    "use strict";

    /**
    * Announcements Section of OnlineBooking Settings 
    */
    export class OnlineBookingAnnouncementsSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:online-booking', isInterop: true, targetRoute: 'online-settings/announcements' });
        }

    }
}